import React from 'react';
import cx from 'classnames';

import Table from '../../../../../components/_table/Table';
import InputForm from '../../../../../components/form/InputForm';
import columns from './columns';
import { compareProductVersion } from '../../../../../lib/utils';
import useFormState from '../../../../../hooks/product/useFormState';
import './ProductFeeInfo.scss';

const ProductFeeInfo = (props) => {
  const { form, isEditable, comparisonData, isCompare, setIsGift } = props;
  const [feeInfo, setFeeInfo] = useFormState(props.feeInfo, { form, key: 'feeInfo' });
  const { productManagementTypeSelectList } = feeInfo;

  return (
    <div className="product-detail-fee-info">
      <Table
        className={cx(
          'fee-info-table',
          isCompare ? 'version-compare' : '',
          isCompare && compareProductVersion(feeInfo, comparisonData),
        )}
        columns={() =>
          columns({
            isEditable,
            form,
            productManagementTypeSelectList,
            setFeeInfo,
            setIsGift,
          })
        }
        list={[feeInfo]}
        scroll={{ x: true }}
        bordered={true}
        showPagination={false}
      />
      <div className="hidden-form">
        <InputForm form={form} type="hidden" name="feeInfo" initialValue={feeInfo} />
      </div>
    </div>
  );
};

export default ProductFeeInfo;
